import React from "react";
import { ArrowRight, SearchX } from "lucide-react";

import {
  Actions,
  Badge,
  Container,
  Description,
  Hero,
  HeroContent,
  HeroIllustration,
  PrimaryAction,
  SecondaryAction,
  SimilarPropertiesSection,
  Title,
} from "./styles";
import errorImg from "./../../assets/components/ErrorPropertyRented/errorImg.png";
import { Property } from "../../global/types";
import SimilarProperties from "../../pages/PropertyDetails/components/SimilarProperties/SimilarProperties";
import { SimilarPropertiesSource } from "../../pages/PropertyDetails/components/SimilarProperties/fetchSimilarProperties";
import { buildSearchLink } from "./buildSearchLink";

interface ErrorPropertyRentedProps {
  similarRents?: Property;
  similarSource?: SimilarPropertiesSource;
}

export default function ErrorPropertyRented({
  similarRents,
  similarSource = "featured",
}: ErrorPropertyRentedProps) {
  return (
    <Container>
      <Hero>
        <HeroContent>
          <Badge>
            <SearchX /> Anúncio indisponível
          </Badge>

          <Title>Imóvel não encontrado</Title>

          <Description>
            Este anúncio saiu do ar ou já foi alugado. Reunimos abaixo outras
            opções para você continuar a busca sem perder tempo.
          </Description>

          <Actions>
            <PrimaryAction to={buildSearchLink(similarRents)}>
              Ver imóveis disponíveis <ArrowRight />
            </PrimaryAction>
            <SecondaryAction to="/">Voltar ao início</SecondaryAction>
          </Actions>
        </HeroContent>

        <HeroIllustration>
          <img src={errorImg} alt="Ilustração de busca por imóveis" />
        </HeroIllustration>
      </Hero>

      <SimilarPropertiesSection>
        <SimilarProperties similarRents={similarRents} source={similarSource} />
      </SimilarPropertiesSection>
    </Container>
  );
}
